<template>
  <div class="notifications-link">
    <woot-button
      v-tooltip.right="$t(`SIDEBAR.NOTIFICATIONS`)"
      class-names="notifications-link--button"
      variant="clear"
      color-scheme=""
      :class="{ 'is-active': isNotificationPanelActive }"
      @click="openNotificationPanel"
    >
      <fluent-icon icon="alert" />
      <span v-if="unreadCount" class="badge warning">{{ unreadCount }}</span>
    </woot-button>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      notificationMetadata: 'notifications/getMeta',
    }),
    unreadCount() {
      if (!this.notificationMetadata.unreadCount) {
        return '';
      }

      return this.notificationMetadata.unreadCount < 100
        ? `${this.notificationMetadata.unreadCount}`
        : '99+';
    },
    isNotificationPanelActive() {
      return this.$route.name === 'notifications_index';
    },
  },
  methods: {
    openNotificationPanel() {
      if (this.$route.name !== 'notifications_index') {
        this.$emit('open-notification-panel');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.notifications-link {
  margin-bottom: var(--space-small);
}

.badge {
  position: absolute;
  border-radius: var(--border-radius-full);
  border: 1.5px solid var(--white);
  height: 1.7rem;
  text-align: center;
  left: var(--space-normal-plus);
  top: 0;
  font-size: var(--font-size-small);
  line-height: 1.5rem;
  padding: 0 var(--space-smaller-plus);
  min-width: 1.9rem;

  &.warning {
    background-color: var(--conversa2-orange-700-color);
    color: var(--white);
  }
}
.notifications-link--button {
  display: flex;
  position: relative;
  border-radius: var(--border-radius-large);
  border: 1px solid transparent;
  color: var(--conversa2-neutral-600-color);
  margin: var(--space-small) 0;

  &:hover {
    background: var(--conversa2-neutral-50-color);
    color: var(--conversa2-neutral-800-color);
  }

  &:focus {
    border-color: var(--conversa2-blue-700-color);
  }

  &.is-active {
    background: var(--conversa2-blue-50-color);
    color: var(--conversa2-blue-700-color);
  }
}
</style>
